import { getAPIUrl } from "../../utils/url/url";
import { makeRequest } from "../baseApi";
import { getGravatarImage } from "../gravatar";

const AVATAR_DEFAULT_WIDTH = 80;

export const getUserAvatar = (userId, email, timestampLastUpdate, width = AVATAR_DEFAULT_WIDTH) => {
  let url = getAPIUrl() + `/avatar/${userId}?w=${width}`;

  if (timestampLastUpdate) {
    url = `${url}&v=${timestampLastUpdate}`;
  }

  /*if (email) {
    return `${url}&d=${encodeURIComponent(getGravatarImage(email))}`;
  }*/

  return url;
};

export const uploadUserAvatar = async (data) => {
  await makeRequest({
    url: "/avatar",
    type: "post",
    data,
    "Content-type": "multipart/form-data",
  });
};

export const deleteUserAvatar = async () => {
  await makeRequest({
    url: "/avatar",
    type: "delete",
  });
};
